import Home from ".";

export const homeRoutes = (data) => [
  {
    path: "/",
    title: "Home",
    layout: "front",
    component: Home,
  },
  {
    path: "/:lang",
    title: "Home",
    layout: "front",
    component: Home,
  },
];
